// perpetual check interval constants in milliseconds
export const IMMEDIATELY = 0;
export const REPETITIVELY = 10;
export const QUICKLY = 100;
export const DEBOUNCE = 500;
export const CONSTANTLY = 1e3;
export const SHORTLY = 2e3;
export const OFTEN = 3e3;
export const FREQUENTLY = 5e3;
export const NORMALLY = 10e3;
export const SLOWLY = 20e3;
export const REGULARLY = 30e3;
export const SOMETIMES = 60e3;
export const TIMEOUT = 90e3;
export const RARELY = 200e3;
export const MIN_CENTRALIZED_TELEMETRY_INVALIDATION_INTERVAL = 5 * 60e3;
export const MAX_CENTRALIZED_TELEMETRY_INVALIDATION_INTERVAL = 30 * 60e3;
export const MIN_PERIODIC_TELEMETRY_INVALIDATION_INTERVAL = 24 * 60 * 60e3; // 1 day
export const MAX_PERIODIC_TELEMETRY_INVALIDATION_INTERVAL = 7 * 24 * 60 * 60e3; // 1 week
